import React from 'react';
import { faCircle } from '@fortawesome/pro-regular-svg-icons/faCircle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function CircleRegularIcon(
  props: React.PropsWithChildren<React.HTMLAttributes<SVGElement>>
) {
  return <FontAwesomeIcon icon={faCircle} {...props} />;
}
